import { ActionTree } from 'vuex'
import { MapState } from './types'
import { RootState } from '../types'
import { LatLng } from '@/helpers/objects'
import ThingsHelpers from '@/helpers/things/thingsHelpers'
import { MapsHelpers } from '@/helpers/mainExports'
import { Thing } from '@/helpers/objects'

declare const google: any

export const actions: ActionTree<MapState, RootState> = {
  initMapState({ commit }): any {
    const payload: MapState = {
      markers: {},
      things: {},
      entitiesFiltered: {},
      map: {},
      payloadIsEmpty: false,
      thingsToFollow: [],
      pondRippleEvent: {},
      isPanoramActive: false,
      streetViewPanoramaElement: null,
      drawerComponent: ''
    }
    commit('initMapState', payload)
  },
  destroyMarkerClusterOnMap({ rootState, rootGetters }) {
    const things = rootGetters['mapState/currentThings']
    const thingValues: Thing[] = Object.values(things)
    if (rootState.markerCluster && thingValues.length) {
      thingValues.forEach(({ marker }) => {
        rootState.markerCluster.removeMarker(marker)
      })
      rootState.markerCluster.setMap(null)
      rootState.markerCluster = null
    }
  },
  filterEntitiesByString({ state, dispatch }, { string }) {
    if (string.length > 1) {
      const filterEntities = Object.values(state.things).filter(
        (entity: any) =>
          entity.name.toLowerCase().match(string) ||
          entity.domain.toLowerCase().match(string)
      )
      state.entitiesFiltered = {}
      filterEntities.forEach(element => {
        state.entitiesFiltered[element.id] = element
      })
    } else {
      dispatch('resetEntities')
    }
  },
  resetEntities({ state }) {
    state.entitiesFiltered = state.things
  },
  switchMapType({ commit }): any {
    commit('switchMapType')
  },
  setMarker({ commit }, payload) {
    commit('setMarker', payload)
  },
  addLocationsThingSelect(
    { state, commit, dispatch, rootState, rootGetters },
    payload
  ) {
    const thing = payload
    const showEntityType = rootGetters['uiState/showEntityType']
    const showEntityName = rootGetters['uiState/showEntityName']
    const id = thing.id
    const name = thing.info.label
    const isAlias = thing.is_alias
    const aliasesQuantity = thing.aliases_qty
    const label = ThingsHelpers.getThingLabel(thing.info.label)
    const domain = ThingsHelpers.getThingDomain(thing)
    const tags = thing.info.tags
    const position = new LatLng({
      lat: ThingsHelpers.getThingLatitude(thing),
      lng: ThingsHelpers.getThingLongitude(thing)
    })
    const heading = ThingsHelpers.getThingHeading(thing.reported_state.heading)
    const lastReport = ThingsHelpers.getThingLastReport(thing)
    /* let fuel_cut_off = false
        if (thing.reported_state.fuel_cut_off) {
          fuel_cut_off = thing.reported_state.fuel_cut_off
        } */
    //"const type" filtra el string del tipo ("vehicle", "flex")
    const type = ThingsHelpers.getThingType(thing)
    //Actualmente el thing "flex" no tiene subtype, al momento se asigna el type como subtype
    const subType = thing.info.subtype ? thing.info.subtype : type
    const status = ThingsHelpers.getThingStatus(type, thing.reported_state)
    //El Follow se setea con el id con info del Local Storage para que en la primer carga de iconos se implemente el icono correcto en el caso que el Thing este siendo marcado para el seguimiento ya que para esta instancia el State no esta cargado
    const follow = ThingsHelpers.isFollowed(id)
    const icon = ThingsHelpers.getThingIcon(
      { status, heading, type, subType, follow },
      showEntityType
    )
    const speed = thing.reported_state.speed
    const services = ThingsHelpers.getThingServices(thing)
    const speedLastModified = ThingsHelpers.getThingSpeedLastModified(thing)
    const signalSensorTimes = thing.metadata.reported_state.signal_sensors
    const fuel_cut_off = thing.reported_state.fuel_cut_off
      ? thing.reported_state.fuel_cut_off
      : false
    const gpsId = thing.things[0]
    const sensors = thing.reported_state.signal_sensors
    const ibutton = thing.reported_state.ibutton
    const dataThing = {
      id,
      name,
      isAlias,
      aliasesQuantity,
      domain,
      tags,
      status,
      signalSensorTimes,
      position,
      heading,
      lastReport,
      type,
      subType,
      speed,
      speedLastModified,
      sensors,
      services,
      fuel_cut_off,
      gpsId,
      ...(type !== 'flex' && {
        batteryStatus:
          thing.reported_state.main_power_on !== null &&
          thing.reported_state.hasOwnProperty('main_power_on')
            ? thing.reported_state.main_power_on
            : true
      }),
      ...(type == 'flex' && {
        batteryLevel: thing.reported_state.battery_level
      }),
      ibutton
    }
    return dataThing
  },
  addLocations({ state, commit, dispatch, rootState, rootGetters }, payload) {
    if (payload.length > 0) {
      // Si ya recibo data detengo el proceso de re render de tabla
      if (state.payloadIsEmpty) commit('stopTime')
      //Obtener el estado de visualización entityType
      const showEntityType = rootGetters['uiState/showEntityType']
      const showEntityName = rootGetters['uiState/showEntityName']
      payload
        .filter(thing => thing.hasOwnProperty('things'))
        .forEach(thing => {
          const id = thing.id
          const name = thing.info.label
          const isAlias = thing.is_alias
          const aliasesQuantity = thing.aliases_qty
          const label = ThingsHelpers.getThingLabel(thing.info.label)
          const domain = ThingsHelpers.getThingDomain(thing)
          const tags = thing.info.tags
          const position = new LatLng({
            lat: ThingsHelpers.getThingLatitude(thing),
            lng: ThingsHelpers.getThingLongitude(thing)
          })
          const heading = ThingsHelpers.getThingHeading(
            thing.reported_state.heading
          )
          const lastReport = ThingsHelpers.getThingLastReport(thing)
          //"const type" filtra el string del tipo ("vehicle", "flex")
          const type = ThingsHelpers.getThingType(thing)
          //Actualmente el thing "flex" no tiene subtype, al momento se asigna el type como subtype
          const subType = thing.info.subtype ? thing.info.subtype : type
          const status = ThingsHelpers.getThingStatus(
            type,
            thing.reported_state
          )
          //El Follow se setea con el id con info del Local Storage para que en la primer carga de iconos se implemente el icono correcto en el caso que el Thing este siendo marcado para el seguimiento ya que para esta instancia el State no esta cargado
          const follow = ThingsHelpers.isFollowed(id)
          const icon = ThingsHelpers.getThingIcon(
            { status, heading, type, subType, follow },
            showEntityType
          )
          const speed = thing.reported_state.speed
          const servicePlan = thing.config?.service_plan
          const services = ThingsHelpers.getThingServices(thing)
          const speedLastModified = ThingsHelpers.getThingSpeedLastModified(
            thing
          )
          const signalSensorTimes = thing.metadata.reported_state.signal_sensors
          const fuel_cut_off = thing.reported_state.fuel_cut_off ?? false
          const contact_on = thing.reported_state.contact_on ?? false
          const gpsId = thing.things[0]
          const created_timestamp = thing.created_timestamp
          const sensors = thing.reported_state.signal_sensors
          const ibutton = thing.reported_state.ibutton
          const dataThing = {
            id,
            name,
            isAlias,
            aliasesQuantity,
            domain,
            tags,
            status,
            position,
            heading,
            lastReport,
            type,
            subType,
            speed,
            signalSensorTimes,
            speedLastModified,
            servicePlan,
            services,
            fuel_cut_off,
            contact_on,
            gpsId,
            telemetry: thing.reported_state.telemetry,
            ...(type != 'flex' && {
              batteryStatus:
                thing.reported_state.hasOwnProperty('main_power_on') &&
                thing.reported_state.main_power_on !== null
                  ? thing.reported_state.main_power_on
                  : true
            }),
            ...(type == 'flex' && {
              batteryLevel: thing.reported_state.battery_level
            }),
            ...(thing.reported_state.telemetry
              ? {
                  fuel_tank: thing.reported_state.telemetry.fuel_tank,
                  rpm_engine: thing.reported_state.telemetry.rpm_engine
                }
              : null),
            created_timestamp: created_timestamp,
            sensors,
            ibutton
          }

          if (!state.things[id]) {
            //checks if the thing has the property "location", if not we didnt create a marker with that thing
            if (thing.reported_state.location) {
              commit('newThing', dataThing)

              const dataToEstablishMarker = {
                id,
                label,
                icon,
                position,
                map: rootState.map,
                showEntityType,
                showEntityName
              }
              // Se revisa que la entidad no esté dada de baja ni sea morosa en el pago del servicio de live tracking
              if (
                services['mrn:service:live_tracking']?.status !== 'suspended' &&
                servicePlan?.status !== 'inactive'
              ) {
                //Necesito que al crear un vehiculo, tambien genere el objeto marker en su state
                commit('setMarker', dataToEstablishMarker)
                // Condicionales para generar el Cluster una vez se hayan creado los markers iniciales
                const amountOfThings = rootGetters['uiState/amountOfThing']
                const clusterCreated = rootGetters['uiState/clusterCreated']
                const showCluster = rootGetters['uiState/showCluster']

                //Verifica cantidad de things en el state igual a la cantidad total del call inicial
                //Que el cluster no se encuentra creado
                //Y las preferncias del usuario muestren el agrupador
                const stateThingsLength = Object.keys(state.things).length
                if (
                  stateThingsLength == amountOfThings &&
                  !clusterCreated &&
                  showCluster
                )
                  dispatch('uiState/toggleVisibleNumerator', true, {
                    root: true
                  })
              }
            }
          } else {
            commit('updateThing', { dataThing })
            const dataToUpdateMarker = {
              id,
              label,
              icon,
              position,
              showEntityType
            }

            commit('updateMarker', dataToUpdateMarker)
          }
        })
      //cuando llegan señales se ejecuta el adjust bounds mientras este el follow prendido y el timer no este funcionando
      //se aplica al final para que se ajuste el mapa con la nueva posicion
      if (
        !rootGetters['uiState/getFollowTimerIsActive'] &&
        rootGetters['uiState/follow']
      ) {
        MapsHelpers.adjustMapBounds()
      }
    } else {
      // Start cronometro una unica vez
      if (!state.payloadIsEmpty) commit('startTime')
    }
    dispatch('showThingsByServicesActive')
  },
  centerOnMarker({ commit, rootState, rootGetters }, id) {
    const map = rootState.map
    const showEntityType = rootGetters['uiState/showEntityType']
    commit('centerOnMarker', { id, map, showEntityType })
  },
  centerOnNotification({ commit, rootState, rootGetters }, position) {
    const map = rootState.map
    const showEntityType = rootGetters['uiState/showEntityType']
    commit('centerOnNotification', { position, map, showEntityType })
  },
  showThingsByServicesActive({ commit }) {
    commit('showThingsByServicesActive')
  },
  cleanMapState({ commit }): any {
    commit('cleanMapState')
  },
  resetMarker({ commit, rootGetters }, payload): any {
    const thing = payload
    const showEntityName = rootGetters['uiState/showEntityName']
    const showEntityType = rootGetters['uiState/showEntityType']
    const follow = rootGetters['uiState/follow']
    commit('resetMarker', {
      thing,
      showEntityName,
      showEntityType,
      follow
    })
  },
  showMoreInfo({ rootGetters, dispatch }) {
    const currentDrawer = rootGetters['uiState/drawerComponent']
    if (currentDrawer !== 'Entities') {
      dispatch('openEntitiesDrawer')
      dispatch('uiState/toggleEntitiesDataTable', null, { root: true })
    }
  },
  openEntitiesDrawer({ commit, getters }) {
    if (getters.drawerComponent !== 'Entities') {
      commit('setDrawerComponent', 'Entities')
    }
  },
  setExpanded({ rootGetters }, thingInfo) {
    const mainDataTable = rootGetters.mainDataTable
    if (mainDataTable.expanded.length > 0) mainDataTable.expanded.pop()
    mainDataTable.expanded.push(thingInfo)
    // Expand es una función nativa del prototipo datatable
    // a la cual estamos accediendo mediante la referencia mainDataTable
    mainDataTable.expand(thingInfo)
  },
  setThingsToFollow({ commit }, payload) {
    commit('setThingsToFollow', payload)
  },
  setStreetViewPanoramaElement({ commit }, { streetViewPanoramaElement }) {
    commit('setStreetViewPanoramaElement', { streetViewPanoramaElement })
  },
  setIsPanoramActive({ commit }, { active }) {
    commit('setIsPanoramActive', { active })
  },
  getThingTelemetryById({ state }, { id }) {
    return state.things[id]?.telemetry
  },
  getThingIbuttonById({ state }, { id }) {
    return state.things[id]?.ibutton
  },
  destroyMarkerOnMap({ commit }, { thing }) {
    commit('destroyMarkerOnMap', thing)
  },
  destroyMarkersOnMap({ state, commit }) {
    for (const key in state.things) {
      if (state.things.hasOwnProperty(key)) {
        const value = state.things[key]
        commit('destroyMarkerOnMap', value)
      }
    }
  },
  refreshReferenceThingsState({ commit }, { things }) {
    commit('refreshReferenceThingsState', { things })
  },
  refreshReferenceEntitiesFilteredState({ commit }, { entitiesFiltered }) {
    commit('refreshReferenceEntitiesFilteredState', { entitiesFiltered })
  }
}
